export default __webpack_public_path__ + "static/media/fridge2-afterA-2048w.87c04f90.avif";